module.exports = __webpack_public_path__ + "static/media/new3@2x.49e701dc.png";